/* BodenWerk Cine-Hero – Szenen-Rotation mit ruhiger Ab-/Aufblende.
   Timer-gesteuert (feste Reihenfolge, gleichmäßiges Tempo) und über die Web
   Animations API animiert (verlässlich, unabhängig von CSS-Transition-Eigenheiten):
   jede Szene läuft HOLD_MS, blendet in FADE_MS ins Dunkle; im Schwarz-Höhepunkt
   werden Videoebene + Text getauscht; danach Aufblende. Beide Videos loopen intern.
   prefers-reduced-motion: keine Rotation, erstes Poster steht still. */
(function () {
  'use strict';

  var FADE_MS = 1300;   // Dauer der Ab- bzw. Aufblende
  var MIN_MS = 3500;    // Mindest-Anzeigedauer je Szene
  var MAX_MS = 9000;    // Höchst-Anzeigedauer je Szene
  var END_BUFFER = 0.2; // Sekunden Puffer vor dem Videoende
  var FALLBACK_MS = 6500; // wenn die Videolänge (noch) unbekannt ist
  var VORLADEN_MS = 2500; // Wartezeit, bevor Szene 2 im Hintergrund geladen wird
  var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

  // Die erste Videoebene bespielt bw-video-rendition.js, das global vor
  // diesem Skript läuft. Von dort kommt auch die Qualitätsstufe für die
  // weiteren Szenen.
  function qualitaet() {
    return window.bwVideoQualitaet || 'hd';
  }

  function quelleFuer(szene) {
    var q = qualitaet();
    if (!szene || q === 'aus') return '';
    if (q === 'sd' && szene.videoSd) return szene.videoSd;
    return szene.video || '';
  }

  // Opacity verlässlich animieren: laufende WAAPI-Animation überschreibt die
  // Inline-Opacity; nach Ende bleibt der gesetzte Inline-Wert stehen (kein Sprung).
  function fadeTo(el, to, dur) {
    if (!el) return Promise.resolve();
    var from = parseFloat(window.getComputedStyle(el).opacity);
    if (isNaN(from)) from = to;
    el.style.opacity = String(to);
    if (!el.animate) return Promise.resolve();
    var a = el.animate([{ opacity: from }, { opacity: to }], { duration: dur, easing: EASE });
    return a.finished ? a.finished.catch(function () {}) : new Promise(function (r) { a.onfinish = r; });
  }

  function nextFrame() {
    return new Promise(function (r) {
      window.requestAnimationFrame(function () { window.requestAnimationFrame(r); });
    });
  }

  function initHero(root) {
    if (!root || root.__bwCineInit) return;
    root.__bwCineInit = true;

    var dataEl = root.querySelector('[data-bw-cine-scenes]');
    if (!dataEl) return;
    var scenes;
    try { scenes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!scenes || scenes.length < 2) return;

    var layers = root.querySelectorAll('.bw-cine__media');
    if (layers.length < 2 || layers[0].tagName !== 'VIDEO') return;

    var fade = root.querySelector('.bw-cine__fade');
    var panel = root.querySelector('[data-bw-cine-panel]');
    var elEyebrow = root.querySelector('[data-bw-cine-eyebrow]');
    var elHeading = root.querySelector('[data-bw-cine-heading]');
    var elText = root.querySelector('[data-bw-cine-text]');
    var elDefaultBtn = root.querySelector('[data-bw-cine-default-btn]');
    var elSceneBtn = root.querySelector('[data-bw-cine-scene-btn]');
    var dots = root.querySelectorAll('[data-bw-cine-dot]');
    var toggle = root.querySelector('[data-bw-cine-toggle]');

    var cur = 0;        // aktuell sichtbare Szene
    var active = 0;     // aktive Videoebene (0/1)
    var busy = false;
    var timer = null;
    var sceneStartedAt = 0; // performance.now() beim tatsächlichen Start der aktiven Szene
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var playing = !reduced && qualitaet() !== 'aus';
    var queued = null;
    var removeMetadata = null;
    var preloadReady = false;

    function inViewport() {
      // Ohne Observer bleibt auch nach dem Scrollen das bisherige Verhalten erhalten.
      if (!window.IntersectionObserver) return true;
      var r = root.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight &&
        r.right > 0 && r.left < window.innerWidth;
    }

    function clearSchedule() {
      window.clearTimeout(timer);
      if (removeMetadata) removeMetadata();
      removeMetadata = null;
    }

    function syncToggle() {
      if (!toggle) return;
      toggle.hidden = qualitaet() === 'aus';
      toggle.textContent = playing ? 'Pause' : 'Abspielen';
      toggle.setAttribute('aria-label', playing ? 'Videos pausieren' : 'Videos abspielen');
    }

    function setText(i) {
      var s = scenes[i];
      if (elEyebrow) elEyebrow.textContent = s.eyebrow || '';
      if (elHeading) elHeading.textContent = s.heading || '';
      if (elText) elText.textContent = s.text || '';
      if (elSceneBtn) {
        var eigener = !!(s.buttonLabel && s.buttonLink);
        elSceneBtn.hidden = !eigener;
        if (eigener) { elSceneBtn.textContent = s.buttonLabel; elSceneBtn.href = s.buttonLink; }
        if (elDefaultBtn) elDefaultBtn.hidden = eigener;
      }
      root.setAttribute('aria-label', s.heading || '');
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === i);
        dots[d].setAttribute('aria-pressed', String(d === i));
      }
    }

    function preload(i, manual) {
      if (!manual && !inViewport()) return;
      var el = layers[1 - active];
      var s = scenes[i];
      if (el.getAttribute('data-scene') === String(i) && (!playing || el.getAttribute('src'))) return;
      el.setAttribute('data-scene', String(i));
      var poster = (window.innerWidth <= 820 && s.posterSm) ? s.posterSm : s.poster;
      if (poster) el.setAttribute('poster', poster);
      var url = quelleFuer(s);
      if (!url || !playing) {
        el.removeAttribute('src');
        el.load();
        return;
      }
      el.src = url;
      el.load();
    }

    // Anzeigedauer an die echte Videolänge koppeln: die Abblende soll genau dann
    // fertig sein, wenn das (nicht loopende) Video endet -> kein harter Loop-Schnitt.
    function holdFor(el) {
      var d = el && el.duration;
      if (!d || isNaN(d) || !isFinite(d)) return null;
      var ms = d * 1000 - FADE_MS - END_BUFFER * 1000;
      return Math.max(MIN_MS, Math.min(ms, MAX_MS));
    }

    // Setzt den Timer relativ zum tatsächlichen Szenenstart (sceneStartedAt), nicht zum
    // Aufrufzeitpunkt von schedule(): schedule() läuft oft erst NACH der ~1,3s-Aufblende
    // bzw. nach einem verspäteten loadedmetadata, sonst würde sich jeder Wechsel um genau
    // diese vergangene Zeit verspäten (Video friert kurz vorm harten Ende ein).
    function armTimer(totalMs) {
      var elapsed = performance.now() - sceneStartedAt;
      var remaining = Math.max(0, totalMs - elapsed);
      timer = window.setTimeout(advance, remaining);
    }

    function schedule() {
      clearSchedule();
      if (!playing || busy || !inViewport()) return;
      var el = layers[active];
      var ms = holdFor(el);
      if (ms == null) {
        // Metadaten noch nicht da -> nachhören und dann korrekt (mit Restzeit) planen.
        var onMeta = function () { schedule(); };
        removeMetadata = function () { el.removeEventListener('loadedmetadata', onMeta); };
        el.addEventListener('loadedmetadata', onMeta);
        armTimer(FALLBACK_MS);
        return;
      }
      armTimer(ms);
    }

    function advance(target, manual) {
      if (!manual && !inViewport()) return;
      var next = Number.isInteger(target) ? target : (cur + 1) % scenes.length;
      if (busy) {
        if (manual) queued = next;
        return;
      }
      if (next === cur) return;
      clearSchedule();
      preload(next, manual);
      busy = true;
      var duration = reduced ? 0 : (manual ? 220 : FADE_MS);
      var incoming = layers[1 - active];

      // 1) Ins Dunkle blenden + Text ausblenden.
      Promise.all([
        fadeTo(fade, 1, duration),
        fadeTo(panel, 0, Math.round(duration * 0.7))
      ]).then(function () {
        // 2) Hinter dem Schwarz: Ebenen tauschen, neue Szene starten, Text setzen.
        try { incoming.currentTime = 0; } catch (e) {}
        if (playing) {
          if (!incoming.getAttribute('src')) {
            incoming.src = quelleFuer(scenes[next]);
            incoming.load();
          }
          var pp = incoming.play();
          if (pp && pp.catch) pp.catch(function () {});
        } else {
          incoming.pause();
        }
        sceneStartedAt = performance.now();
        incoming.classList.add('bw-cine__media--active');
        layers[active].classList.remove('bw-cine__media--active');
        try { layers[active].pause(); } catch (e) {}
        active = 1 - active;
        cur = next;
        setText(cur);
        return nextFrame();
      }).then(function () {
        // 3) Aus dem Dunkel aufblenden + neuen Text einblenden.
        return Promise.all([
          fadeTo(fade, 0, duration),
          fadeTo(panel, 1, duration)
        ]);
      }).then(function () {
        busy = false;
        if (queued !== null) {
          var requested = queued;
          queued = null;
          if (requested !== cur) {
            advance(requested, true);
            return;
          }
        }
        if (playing) preload((cur + 1) % scenes.length);
        schedule();
      });
    }

    var first = layers[0];
    // Kein loop: jedes Video läuft einmal durch; der Timer schaltet vor dem Ende weiter.
    first.removeAttribute('loop');

    first.setAttribute('data-scene', '0');
    layers[1].removeAttribute('loop');
    if (fade) fade.style.opacity = '0';

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        advance(Number(dot.getAttribute('data-bw-cine-dot')), true);
      });
    });
    if (toggle) toggle.addEventListener('click', function () {
      playing = !playing;
      clearSchedule();
      syncToggle();
      if (!playing) {
        layers.forEach(function (el) { el.pause(); });
        return;
      }
      var el = layers[active];
      if (!el.getAttribute('src')) {
        el.src = quelleFuer(scenes[cur]);
        el.load();
      }
      if (el.ended) el.currentTime = 0;
      var p = el.play();
      if (p && p.catch) p.catch(function () {});
      sceneStartedAt = performance.now() - (el.currentTime || 0) * 1000;
      if (!busy) preload((cur + 1) % scenes.length);
      schedule();
    });
    syncToggle();

    layers.forEach(function (el) {
      el.addEventListener('ended', function () {
        if (playing && el === layers[active]) advance();
      });
    });

    window.setTimeout(function () {
      preloadReady = true;
      if (playing && !busy) preload((cur + 1) % scenes.length);
    }, VORLADEN_MS);

    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function () {
        if (!inViewport()) {
          clearSchedule();
          return;
        }
        if (playing && !busy && preloadReady) preload((cur + 1) % scenes.length);
        schedule();
      // Zusätzliche Schwelle weckt auch nach einer Berührung mit 0 px Schnittfläche.
      }, { threshold: [0, 0.001] });
      observer.observe(root);
    }

    if (playing) {
      var p = first.play();
      if (p && p.catch) p.catch(function () {});
      sceneStartedAt = performance.now();
      schedule();
    } else {
      first.pause();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bw-cine][data-bw-rotate]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
